// Protected Admin Route Wrapper
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAdminAuth } from '../utils/authContext';
import AdminLayout from '../components/AdminLayout';

const ProtectedAdminRoute = ({ children }) => {
  const { admin, loading } = useAdminAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center">
        <div className="text-white">Loading...</div>
      </div>
    );
  }

  if (!admin) {
    return <Navigate to="/neuro-admin-access/login" replace />;
  }

  return <AdminLayout>{children}</AdminLayout>;
};

export default ProtectedAdminRoute;
